/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import Media from 'react-media';
import MobileGiftListLogin from './MobileGiftList/Layouts/MobileGiftListLogin';
import DesktopGiftListLogin from './DesktopGiftList/Layouts/DesktopGiftListLogin';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import configENV from '../../config';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';

const { PERSIST_KEY } = configENV;

class GiftListLogin extends React.PureComponent {
    render() {
        const {
            isPageReady,
        } = this.props;
        if (!isPageReady) return null;
        const breakpointExpr =  `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
        return (
            <Media query={breakpointExpr}>
                {(matches) => (       // eslint-disable-line arrow-parens
                    matches ? (
                        <>
                            <MobileGiftListLogin />
                        </>
                    ) : (
                        <>
                            <DesktopGiftListLogin />
                        </>
                    )
                )}
            </Media>
        );
    }
}

GiftListLogin.propTypes = {
    isPageReady: bool.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    // console.log('GiftListUser - newStat', newState);
    return {
        toggleState: newState.toggleState,
    };
};

const enhance = compose(
    withPageView({
        pageViewSuccessTest: () => true,
    }),
    withRouter,
    connect(mapStateToProps),
);

export default enhance(GiftListLogin);
